import { jsx as l } from "react/jsx-runtime";
const m = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...h,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m12.758 11.5 1.458-.39L13 3H3L1.5 13h11.66l-.402-1.5Zm-2.246-7h1.196l.412 2.746h-1.608V4.5Zm-5.002 7H3.243l.413-2.754H5.51V11.5Zm0-4.254H3.88L4.292 4.5H5.51v2.746ZM9.012 11.5H7.01V8.746h2.002V11.5Zm0-4.254H7.01V4.5h2.002v2.746Zm1.5 4.254V8.746h1.833l.413 2.754h-2.246Z"
      }
    )
  }
);
export {
  m as Solar
};
